<template>
  <div>
    <v-row v-for="(part, partIndex) in offer.parts" :key="part">
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.carrier')" filled readonly v-model="part.carrier"></v-text-field>
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.flightNumber')" filled readonly v-model="part.flight_number"></v-text-field>
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.baggage')" filled readonly v-model="part.baggage"></v-text-field>
      </v-col>

      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.startFlightDate')" filled readonly v-model="part.start_date"></v-text-field>
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.arrivalDate')" filled readonly v-model="part.end_date"></v-text-field>
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.class')" filled readonly v-model="part.seat_class"></v-text-field>
      </v-col>

      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.fromPlace')" filled readonly v-model="part.from"></v-text-field>
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.toPlace')" filled readonly v-model="part.to"></v-text-field>
      </v-col>

      <v-col class="pa-1" cols="12">
        <v-textarea :label="$t('travelService.travelAgentComment')" filled readonly v-model="part.comment"></v-textarea>
      </v-col>
      <v-col v-if="partIndex < offer.parts.length - 1" cols="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "FlightResponsePresentation",
  props: {
    offer: {
      required: true
    }
  }
};
</script>

<style scoped></style>
